<template>
    <textarea
        v-if="name === '6pVB6vfbUx'"
        :name="name"
        v-bind="combinedAttributes"
        v-model="innerValue"
        class="form-control my-1"
    />
    <ckeditor
        v-else
        :name="name"
        v-bind="combinedAttributes"
        v-model="innerValue"
        class="form-control my-1"
    />
</template>

<script>
    import ValueForwarder from '~/mixins/value-forwarder'
    import Ckeditor from "~/components/elements/raw-ckeditor";
    import axios from 'axios';

    export default {
        name: 'ad-textarea',
        mixins: [
            ValueForwarder,
        ],
        components: {
            'ckeditor': Ckeditor,
        },
        props: {
            name: {
                required: true,
            },
            properties: {
                required: false,
                default: () => {
                    return {};
                },
            },
            
            options: {
                required: false,
            },
            trajectoryEnrolment: {
                type: Object,
                required: false,
            },
            actionProgress: {
                type: Object,
                required: false,
            },
            actionProgressId: {
                type: Number,
                required: false,
            },
            check: {
                type: Boolean,
                default: false,
            },
            checkId: {
                type: Number,
                required: false,
            },
        },
        computed: {
            combinedAttributes() {
                return {
                    ...this.properties,
                    ...this.$attrs
                };
            }
        },
        async mounted() {
            if (this.name === '6pVB6vfbUx' && (this.innerValue === '' || this.innerValue == null || this.innerValue === undefined)) {
                try {
                    await this.retrieveReport();
                } catch (error) {
                    console.error('Error fetching report:', error);
                }
            }
        },
        watch: {
            innerValue(newVal, oldVal) {
                this.$emit('send-event-to-component', {name: this.name, value: this.innerValue});
            }
        },
        methods: {
            async retrieveReport() {
                try {
                    const response = await axios.get(`/api/fetch-all-report-data/${this.trajectoryEnrolment.id}/${this.actionProgress.id ? this.actionProgress.id : ''}`);
                    const suggestStartDate = response.data.allActionProgresses[0].suggestStartDate;
                    const suggestEndDate = response.data.allActionProgresses[0].suggestEndDate;
                    this.innerValue = `${suggestStartDate} t/m ${suggestEndDate}`;
                } catch (error) {
                    console.error('Error fetching report data:', error);
                }
            }
        }
    };
</script>

<style scoped>

</style>
